import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";

const LEVELS = [["", "Yok"], ["view", "Görüntüle"], ["pay", "Görüntüle + Ödeme Gir"]];
const level = (p) => (p.includes("pay") ? "pay" : p.includes("view") ? "view" : "");
const acts = (l) => (l === "pay" ? ["view", "pay"] : l === "view" ? ["view"] : []);

export default function ZekatSettingsTab() {
  const [s, setS] = useState(null);
  const [rate, setRate] = useState("");
  const [from, setFrom] = useState("");
  const [roles, setRoles] = useState({});
  const [users, setUsers] = useState({});
  const [busy, setBusy] = useState(false);
  const fill = (d) => { setS(d); setRate(String(d.rate_percent)); setFrom(d.current_month); setRoles(Object.fromEntries(d.roles.map((r) => [r.key, level(r.perms)]))); setUsers(Object.fromEntries(d.users.map((u) => [u.id, level(u.perms)]))); };
  useEffect(() => { api.get("/zekat/settings").then(({ data }) => fill(data)).catch((e) => toast.error(apiError(e))); }, []);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/zekat/settings", { rate_percent: Number(String(rate).replace(",", ".")), from_month: from,
        roles: Object.fromEntries(Object.entries(roles).map(([k, v]) => [k, acts(v)])), users: Object.fromEntries(Object.entries(users).map(([k, v]) => [k, acts(v)])) });
      fill(data); toast.success("Zekat ayarları kaydedildi");
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  if (!s) return <Loader2 className="h-5 w-5 animate-spin" />;
  const pick = (val, on, testid) => (
    <select className="h-8 px-2 rounded border border-slate-200 text-[12px]" value={val} onChange={(e) => on(e.target.value)} data-testid={testid}>{LEVELS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>);
  return (
    <div className="panel p-4 space-y-5 max-w-4xl" data-testid="zekat-settings">
      <div>
        <h3 className="font-semibold mb-2">Zekat Oranı</h3>
        <div className="flex items-end gap-3">
          <label className="text-xs text-slate-500">Oran (%)<Input className="w-28 mt-1" inputMode="decimal" value={rate} onChange={(e) => setRate(e.target.value)} data-testid="zekat-settings-rate" /></label>
          <label className="text-xs text-slate-500">Geçerli olduğu ay<Input type="month" className="w-40 mt-1" min={s.current_month} value={from} onChange={(e) => setFrom(e.target.value)} data-testid="zekat-settings-from" /></label>
          <p className="text-[11px] text-slate-500 pb-2">Kapanmış aylar hesaplandıkları oranı korur; değişiklik cari ay veya sonrasından geçerlidir.</p>
        </div>
        <div className="text-[11px] text-slate-500 mt-2" data-testid="zekat-settings-history">Geçmiş: {s.rates.map((r) => `${r.from_month}'den %${r.rate_percent} (${r.set_by})`).join(" · ")}</div>
      </div>
      <div>
        <h3 className="font-semibold mb-2">Rol Yetkileri</h3>
        <div className="grid sm:grid-cols-2 gap-2">{s.roles.map((r) => (
          <div key={r.key} className="flex items-center justify-between border border-slate-200 rounded px-2 py-1 text-[13px]"><span>{r.name}</span>
            {r.is_super ? <span className="text-[11px] text-slate-500">Tam yetki</span> : pick(roles[r.key], (v) => setRoles({ ...roles, [r.key]: v }), `zekat-role-${r.key}`)}</div>))}</div>
      </div>
      <div>
        <h3 className="font-semibold mb-2">Kullanıcıya Özel Ek Yetki</h3>
        <div className="grid sm:grid-cols-2 gap-2 max-h-72 overflow-y-auto">{s.users.map((u) => (
          <div key={u.id} className="flex items-center justify-between border border-slate-200 rounded px-2 py-1 text-[12px]"><span className="truncate">{u.name} <span className="text-slate-400">{u.email}</span></span>
            {pick(users[u.id], (v) => setUsers({ ...users, [u.id]: v }), `zekat-user-${u.email}`)}</div>))}</div>
        <p className="text-[11px] text-slate-500 mt-1">Rol yetkisine eklenir. Maliyet/kâr rakamları ayrıca kullanıcının Maliyet/Kâr Görme yetkisine bağlıdır.</p>
      </div>
      <Button onClick={save} disabled={busy} data-testid="zekat-settings-save"><Save className="h-4 w-4 mr-1" />Kaydet</Button>
    </div>
  );
}
